import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    position: relative;
  }
`;

export const StyledHeadingWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    position: absolute;
    top: ${rem('-56px')};
    right: 0;
    left: 0;
    display: block;
    width: 100%;
  }
`;
